import { Block, Box, ListItem } from '@rulebooks/evidend-titan';
import { t } from '@lingui/macro';
import type { SummaryCardsComponentProps } from 'helpers/formatMutation';
import React from 'react';
import { ShareholderCapitalCard } from 'summaries/CapitalCards/ShareholderCapitalCard';
import { DeedCard } from 'summaries/DeedCard/DeedCard';

export const EndDirectorshipSummaryCards = ({
  backgroundVariant = 'white',
  mutation,
  onDocumentSave,
}: SummaryCardsComponentProps) => {
  const endDirectorships = mutation.endDirectorship || [];

  return (
    <>
      {!!endDirectorships.length && (
        <Box spaceAfter={10}>
          {endDirectorships.map((endDirectorship) => (
            <ShareholderCapitalCard
              key={endDirectorship.directorshipId}
              backgroundVariant={backgroundVariant}
              party={endDirectorship.director}
            >
              <ListItem prefixAdornment="•">{t`End of directorship`}</ListItem>
            </ShareholderCapitalCard>
          ))}
        </Box>
      )}

      {mutation.document && (
        <Block spaceAfter={10}>
          <DeedCard
            backgroundVariant={backgroundVariant}
            document={mutation.document}
            mutation={mutation}
            onDocumentSave={onDocumentSave}
          />
        </Block>
      )}
    </>
  );
};
